import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchPreQualQuestions } from '../../../utilities/preQualServices';

export const fetchPreQualQuestion = createAsyncThunk(
    'fetchPreQualQuestions', fetchPreQualQuestions
)


const initialState = {
    preQualQuestions: [],
    additionalQuestions: [],
    isPreQualQuesAvailable: false,
    DrugEnabled: false
}

const preQualQuestionsSlice = createSlice({
    name: 'fetchPreQualQuestions',
    initialState,
    reducers: {
        resetPreQualQuestions: (state) => {
            state.preQualQuestions = []
            state.additionalQuestions = []
            state.isPreQualQuesAvailable = false
            state.DrugEnabled = false
        },
        setPreQualQuestion: (state, action) => {
            if (action.payload.name == "preQual") {
                state.preQualQuestions[action?.payload?.index][action?.payload?.questionType] = action?.payload?.answer;
            } else if (action.payload.name == "multiSelect") {
                state.additionalQuestions[action?.payload?.index].AnswersList[action.payload.index2].isChecked = action?.payload?.answer;
            } else {
                state.additionalQuestions[action?.payload?.index][action?.payload?.questionType] = action?.payload?.answer;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPreQualQuestion.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(fetchPreQualQuestion.fulfilled, (state, action) => {
                if (action?.payload?.ResponseDetails?.ResponseCode == "PQQ101") {
                    const uniqueQuestion = new Set()
                    const preQualQuestions = action?.payload?.PreQualQuestions?.map((element) => {
                        const isDuplicate = uniqueQuestion.has(element.QuestionID);
                        uniqueQuestion.add(element.QuestionID);
                        if (!isDuplicate) {
                            if (element.AnswerType == "YesNo") {
                                return {
                                    AnswerType: element.AnswerType,
                                    ID: element.QuestionID,
                                    Question: element.Question,
                                    "pxObjClass": "PAF-Data-QuestionsCatalogue",
                                    YesNoAnswer: "No",
                                    GroupID: element?.GroupID
                                }
                            } else if (element.AnswerType == "Drop-down") {
                                return {
                                    Answer: undefined,
                                    AnswerType: element.AnswerType,
                                    ID: element.QuestionID,
                                    pxObjClass: element.pxObjClass,
                                    Question: element?.Question,
                                    GroupID: element?.GroupID,
                                    AnswersList: element.AnswersList
                                }
                            }
                        }
                    });
                    const additionalQuestions = action?.payload?.AdditionalDataQuestionsList?.map((element) => {
                        if (element.AnswerType == "YesNo") {
                            return {
                                AnswerType: element.AnswerType,
                                ID: element.ID,
                                Question: element.Question,
                                "pxObjClass": "PAF-Data-QuestionsCatalogue",
                                YesNoAnswer: "No",
                                GroupID: element?.GroupID
                            }
                        } else if (element.AnswerType == "Drop-down") {
                            return {
                                Answer: undefined,
                                AnswerType: element.AnswerType,
                                ID: element.ID,
                                pxObjClass: element.pxObjClass,
                                Question: element?.Question,
                                GroupID: element?.GroupID,
                                AnswersList: element.AnswersList
                            }
                        } else if (element.AnswerType == "Multi-select") {
                            let tempArrr = []
                            element.AnswersList.map((data) => {
                                tempArrr.push(
                                    {
                                        value: data.Answer,
                                        isChecked: false
                                    }
                                )
                            })
                            return {
                                AnswerType: element.AnswerType,
                                ID: element.ID,
                                pxObjClass: element.pxObjClass,
                                Question: element.Question,
                                AnswersList: tempArrr,
                                MaximumNumberOfAllowableAnswers: element.MaximumNumberOfAllowableAnswers
                            }
                        }
                    })
                    state.DrugEnabled = action?.payload?.FundCaseReference?.Fund?.EligibilityConditions?.IsLimitedDrugs == "true"
                    state.preQualQuestions = preQualQuestions
                    state.isPreQualQuesAvailable = true
                    state.additionalQuestions = additionalQuestions
                } else {
                    toast.error(action?.payload?.ResponseDetails?.ResponseMessage)
                }
            })
            .addCase(fetchPreQualQuestion.rejected, (state, action) => {
                toast.error(action.error.message)
            })
    },
})

export const { resetPreQualQuestions, setPreQualQuestion } = preQualQuestionsSlice.actions

export default preQualQuestionsSlice.reducer